import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { menuActions } from "../store/menuSlice";
import AddUser from "./users/AddUser";
import AddNotification from "./notifications/AddNotification";
import { GameOptions } from "./game_rules/GameOptions";
import { hasMinimumRole, isAdmin, ROLES } from "../utils/roleUtils";

export default function AddItemComponent() {
  const { category } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(menuActions.changeActiveCategory({ category: category }));
  }, [dispatch, category]);

  return (
    <>
      {(isAdmin() && category === "users") && <AddUser />}
      {(hasMinimumRole(ROLES.OFFICIAL_1) && category === "notifications") && <AddNotification />}
      {(hasMinimumRole(ROLES.OFFICIAL_1) && category === "games") && <GameOptions />}
    </>
  );
}
